import type { Driver } from "../api";
import LocationToggle from "./LocationToggle";

export default function Header({
  driver,
  onSwitchDriver,
  onHome,
}: {
  driver: Driver;
  onSwitchDriver: () => void;
  onHome: () => void;
}) {
  return (
    <header className="flex items-center justify-between">
      <button onClick={onHome} aria-label="Back to start" className="active:scale-95">
        <img src="/logo.png" alt="Soulcake" className="h-11" />
      </button>
      <div className="flex items-center gap-2">
        <LocationToggle />
        <button
          onClick={onSwitchDriver}
          className="flex min-h-11 items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-bold border border-line"
          title="Switch driver"
        >
          <span className="inline-block size-2 rounded-full bg-rose" />
          {driver.name}
        </button>
      </div>
    </header>
  );
}
